import { render, staticRenderFns } from "./change-dorm.vue?vue&type=template&id=679abf5c&scoped=true"
import script from "./change-dorm.vue?vue&type=script&lang=js"
export * from "./change-dorm.vue?vue&type=script&lang=js"
import style0 from "./change-dorm.vue?vue&type=style&index=0&id=679abf5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679abf5c",
  null
  
)

export default component.exports